import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=460d6b2e&scoped=true&"
import script from "./GoodsClass.vue?vue&type=script&lang=js&"
export * from "./GoodsClass.vue?vue&type=script&lang=js&"
import style0 from "./GoodsClass.vue?vue&type=style&index=0&id=460d6b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d6b2e",
  null
  
)

export default component.exports